module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal-in-the-wild"
  }, [_c('div', {
    on: {
      "click": _vm.toggleModal
    }
  }, [_c('icons'), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97ababa6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalInTheWild.vue
// module id = 1778
// module chunks = 0